/**
 * Timezone constants and helpers.
 * Extracted from WanderAppComplete.jsx for shared use by web and mobile.
 *
 * Functions that originally used closure-scoped caches now accept
 * an explicit helpers parameter. Web wraps them with its local caches.
 */

// ─── City to IANA Timezone ──────────────────────────────────────────────────

export const CITY_TO_IANA_TIMEZONE = {
  // Americas
  'nyc': 'America/New_York', 'new york': 'America/New_York', 'new york city': 'America/New_York', 'boston': 'America/New_York',
  'miami': 'America/New_York', 'atlanta': 'America/New_York', 'washington': 'America/New_York',
  'philadelphia': 'America/New_York', 'orlando': 'America/New_York', 'charlotte': 'America/New_York',
  'chicago': 'America/Chicago', 'dallas': 'America/Chicago', 'houston': 'America/Chicago',
  'austin': 'America/Chicago', 'nashville': 'America/Chicago', 'minneapolis': 'America/Chicago',
  'denver': 'America/Denver', 'salt lake city': 'America/Denver', 'albuquerque': 'America/Denver',
  'phoenix': 'America/Phoenix',
  'los angeles': 'America/Los_Angeles', 'la': 'America/Los_Angeles', 'san francisco': 'America/Los_Angeles',
  'seattle': 'America/Los_Angeles', 'portland': 'America/Los_Angeles', 'san diego': 'America/Los_Angeles',
  'las vegas': 'America/Los_Angeles', 'sacramento': 'America/Los_Angeles',
  'anchorage': 'America/Anchorage',
  'honolulu': 'Pacific/Honolulu', 'maui': 'Pacific/Honolulu', 'kauai': 'Pacific/Honolulu',
  'oahu': 'Pacific/Honolulu', 'kona': 'Pacific/Honolulu', 'hilo': 'Pacific/Honolulu',
  'toronto': 'America/Toronto', 'vancouver': 'America/Vancouver', 'montreal': 'America/Toronto',
  'calgary': 'America/Edmonton', 'edmonton': 'America/Edmonton', 'winnipeg': 'America/Winnipeg',
  'halifax': 'America/Halifax', 'st johns': 'America/St_Johns',
  'mexico city': 'America/Mexico_City', 'cancun': 'America/Cancun', 'puerto vallarta': 'America/Mexico_City',
  'los cabos': 'America/Mazatlan', 'cabo san lucas': 'America/Mazatlan', 'tulum': 'America/Cancun',
  'playa del carmen': 'America/Cancun', 'oaxaca': 'America/Mexico_City', 'guadalajara': 'America/Mexico_City',
  'lima': 'America/Lima', 'cusco': 'America/Lima', 'arequipa': 'America/Lima',
  'bogota': 'America/Bogota', 'medellin': 'America/Bogota', 'cartagena': 'America/Bogota',
  'buenos aires': 'America/Argentina/Buenos_Aires', 'mendoza': 'America/Argentina/Mendoza',
  'cordoba': 'America/Argentina/Cordoba', 'bariloche': 'America/Argentina/Salta', 'ushuaia': 'America/Argentina/Ushuaia',
  'santiago': 'America/Santiago', 'valparaiso': 'America/Santiago',
  'rio de janeiro': 'America/Sao_Paulo', 'sao paulo': 'America/Sao_Paulo', 'salvador': 'America/Bahia',
  'el calafate': 'America/Argentina/Rio_Gallegos', 'puerto natales': 'America/Punta_Arenas',
  'punta arenas': 'America/Punta_Arenas',
  'havana': 'America/Havana', 'san juan': 'America/Puerto_Rico',
  'panama city': 'America/Panama', 'san jose': 'America/Costa_Rica',
  'nassau': 'America/Nassau', 'kingston': 'America/Jamaica',
  // Europe
  'london': 'Europe/London', 'edinburgh': 'Europe/London', 'manchester': 'Europe/London',
  'birmingham': 'Europe/London', 'glasgow': 'Europe/London',
  'dublin': 'Europe/Dublin', 'lisbon': 'Europe/Lisbon', 'porto': 'Europe/Lisbon',
  'paris': 'Europe/Paris', 'nice': 'Europe/Paris', 'lyon': 'Europe/Paris', 'marseille': 'Europe/Paris',
  'strasbourg': 'Europe/Paris', 'bordeaux': 'Europe/Paris', 'toulouse': 'Europe/Paris',
  'antibes': 'Europe/Paris', 'cannes': 'Europe/Paris', 'monaco': 'Europe/Paris',
  'monte carlo': 'Europe/Paris', 'saint tropez': 'Europe/Paris', 'st tropez': 'Europe/Paris',
  'avignon': 'Europe/Paris', 'aix-en-provence': 'Europe/Paris', 'montpellier': 'Europe/Paris',
  'megeve': 'Europe/Paris', 'megève': 'Europe/Paris', 'chamonix': 'Europe/Paris',
  'courchevel': 'Europe/Paris', 'val disere': 'Europe/Paris', 'annecy': 'Europe/Paris',
  'nantes': 'Europe/Paris', 'rennes': 'Europe/Paris', 'lille': 'Europe/Paris',
  'madrid': 'Europe/Madrid', 'barcelona': 'Europe/Madrid', 'seville': 'Europe/Madrid',
  'valencia': 'Europe/Madrid', 'malaga': 'Europe/Madrid', 'bilbao': 'Europe/Madrid',
  'granada': 'Europe/Madrid', 'san sebastian': 'Europe/Madrid',
  'tenerife': 'Atlantic/Canary', 'gran canaria': 'Atlantic/Canary', 'lanzarote': 'Atlantic/Canary',
  'fuerteventura': 'Atlantic/Canary', 'las palmas': 'Atlantic/Canary',
  'rome': 'Europe/Rome', 'milan': 'Europe/Rome', 'florence': 'Europe/Rome', 'venice': 'Europe/Rome',
  'naples': 'Europe/Rome', 'amalfi': 'Europe/Rome', 'sicily': 'Europe/Rome', 'sardinia': 'Europe/Rome',
  'berlin': 'Europe/Berlin', 'munich': 'Europe/Berlin', 'frankfurt': 'Europe/Berlin',
  'hamburg': 'Europe/Berlin', 'cologne': 'Europe/Berlin', 'dusseldorf': 'Europe/Berlin',
  'amsterdam': 'Europe/Amsterdam', 'rotterdam': 'Europe/Amsterdam',
  'brussels': 'Europe/Brussels', 'bruges': 'Europe/Brussels',
  'vienna': 'Europe/Vienna', 'salzburg': 'Europe/Vienna', 'innsbruck': 'Europe/Vienna',
  'prague': 'Europe/Prague',
  'budapest': 'Europe/Budapest',
  'warsaw': 'Europe/Warsaw', 'krakow': 'Europe/Warsaw', 'gdansk': 'Europe/Warsaw',
  'zurich': 'Europe/Zurich', 'geneva': 'Europe/Zurich', 'interlaken': 'Europe/Zurich',
  'lucerne': 'Europe/Zurich', 'bern': 'Europe/Zurich', 'zermatt': 'Europe/Zurich',
  'st. moritz': 'Europe/Zurich', 'grindelwald': 'Europe/Zurich',
  'athens': 'Europe/Athens', 'santorini': 'Europe/Athens', 'mykonos': 'Europe/Athens',
  'crete': 'Europe/Athens', 'rhodes': 'Europe/Athens', 'corfu': 'Europe/Athens',
  'istanbul': 'Europe/Istanbul', 'cappadocia': 'Europe/Istanbul', 'antalya': 'Europe/Istanbul',
  'stockholm': 'Europe/Stockholm', 'copenhagen': 'Europe/Copenhagen',
  'oslo': 'Europe/Oslo', 'bergen': 'Europe/Oslo', 'tromso': 'Europe/Oslo',
  'helsinki': 'Europe/Helsinki', 'rovaniemi': 'Europe/Helsinki',
  'reykjavik': 'Atlantic/Reykjavik',
  'tallinn': 'Europe/Tallinn', 'riga': 'Europe/Riga', 'vilnius': 'Europe/Vilnius',
  'bucharest': 'Europe/Bucharest', 'sofia': 'Europe/Sofia', 'belgrade': 'Europe/Belgrade',
  'zagreb': 'Europe/Zagreb', 'ljubljana': 'Europe/Ljubljana',
  'dubrovnik': 'Europe/Zagreb', 'split': 'Europe/Zagreb',
  // Faroe Islands & North Atlantic
  'tórshavn': 'Atlantic/Faroe', 'torshavn': 'Atlantic/Faroe', 'faroe': 'Atlantic/Faroe',
  // Middle East & Africa
  'dubai': 'Asia/Dubai', 'abu dhabi': 'Asia/Dubai', 'doha': 'Asia/Qatar',
  'riyadh': 'Asia/Riyadh', 'jeddah': 'Asia/Riyadh',
  'cairo': 'Africa/Cairo', 'luxor': 'Africa/Cairo',
  'marrakech': 'Africa/Casablanca', 'fes': 'Africa/Casablanca', 'casablanca': 'Africa/Casablanca',
  'cape town': 'Africa/Johannesburg', 'johannesburg': 'Africa/Johannesburg',
  'nairobi': 'Africa/Nairobi', 'dar es salaam': 'Africa/Dar_es_Salaam',
  'zanzibar': 'Africa/Dar_es_Salaam', 'addis ababa': 'Africa/Addis_Ababa',
  'accra': 'Africa/Accra', 'lagos': 'Africa/Lagos',
  // Asia
  'tokyo': 'Asia/Tokyo', 'kyoto': 'Asia/Tokyo', 'osaka': 'Asia/Tokyo',
  'hiroshima': 'Asia/Tokyo', 'nara': 'Asia/Tokyo', 'sapporo': 'Asia/Tokyo',
  'fukuoka': 'Asia/Tokyo', 'okinawa': 'Asia/Tokyo', 'nagoya': 'Asia/Tokyo',
  'niseko': 'Asia/Tokyo', 'hakuba': 'Asia/Tokyo',
  'seoul': 'Asia/Seoul', 'busan': 'Asia/Seoul', 'jeju': 'Asia/Seoul',
  'beijing': 'Asia/Shanghai', 'shanghai': 'Asia/Shanghai', 'guangzhou': 'Asia/Shanghai',
  'hong kong': 'Asia/Hong_Kong', 'macau': 'Asia/Macau',
  'taipei': 'Asia/Taipei', 'kaohsiung': 'Asia/Taipei',
  'singapore': 'Asia/Singapore',
  'kuala lumpur': 'Asia/Kuala_Lumpur', 'penang': 'Asia/Kuala_Lumpur', 'langkawi': 'Asia/Kuala_Lumpur',
  'bangkok': 'Asia/Bangkok', 'chiang mai': 'Asia/Bangkok', 'phuket': 'Asia/Bangkok',
  'koh samui': 'Asia/Bangkok', 'krabi': 'Asia/Bangkok',
  'hanoi': 'Asia/Ho_Chi_Minh', 'ho chi minh': 'Asia/Ho_Chi_Minh', 'da nang': 'Asia/Ho_Chi_Minh',
  'hoi an': 'Asia/Ho_Chi_Minh', 'sapa': 'Asia/Ho_Chi_Minh',
  'bali': 'Asia/Makassar', 'lombok': 'Asia/Makassar',
  'jakarta': 'Asia/Jakarta',
  'phnom penh': 'Asia/Phnom_Penh', 'siem reap': 'Asia/Phnom_Penh',
  'manila': 'Asia/Manila', 'cebu': 'Asia/Manila', 'boracay': 'Asia/Manila', 'palawan': 'Asia/Manila',
  'colombo': 'Asia/Colombo', 'kathmandu': 'Asia/Kathmandu',
  'mumbai': 'Asia/Kolkata', 'delhi': 'Asia/Kolkata', 'jaipur': 'Asia/Kolkata',
  'goa': 'Asia/Kolkata', 'bangalore': 'Asia/Kolkata', 'kolkata': 'Asia/Kolkata',
  'kerala': 'Asia/Kolkata', 'chennai': 'Asia/Kolkata', 'hyderabad': 'Asia/Kolkata',
  'maldives': 'Indian/Maldives', 'male': 'Indian/Maldives',
  // Oceania
  'sydney': 'Australia/Sydney', 'melbourne': 'Australia/Melbourne',
  'brisbane': 'Australia/Brisbane',
  'perth': 'Australia/Perth',
  'adelaide': 'Australia/Adelaide', 'hobart': 'Australia/Hobart',
  'darwin': 'Australia/Darwin',
  'auckland': 'Pacific/Auckland', 'queenstown': 'Pacific/Auckland',
  'wellington': 'Pacific/Auckland', 'christchurch': 'Pacific/Auckland',
  'fiji': 'Pacific/Fiji', 'suva': 'Pacific/Fiji', 'nadi': 'Pacific/Fiji',
  'tahiti': 'Pacific/Tahiti', 'bora bora': 'Pacific/Tahiti', 'moorea': 'Pacific/Tahiti',
  // Indian Ocean
  'mauritius': 'Indian/Mauritius', 'seychelles': 'Indian/Mahe',
  'reunion': 'Indian/Reunion', 'réunion': 'Indian/Reunion',
  // Safari, remote, and game reserve destinations
  'sabi sand': 'Africa/Johannesburg', 'sabi sand game reserve': 'Africa/Johannesburg',
  'kruger': 'Africa/Johannesburg', 'kruger national park': 'Africa/Johannesburg',
  'mpumalanga': 'Africa/Johannesburg', 'limpopo': 'Africa/Johannesburg',
  'pretoria': 'Africa/Johannesburg', 'durban': 'Africa/Johannesburg',
  'garden route': 'Africa/Johannesburg', 'stellenbosch': 'Africa/Johannesburg',
  'bazaruto': 'Africa/Maputo', 'bazaruto island': 'Africa/Maputo',
  'vilanculos': 'Africa/Maputo', 'maputo': 'Africa/Maputo',
  'inhambane': 'Africa/Maputo', 'tofo': 'Africa/Maputo',
  'masai mara': 'Africa/Nairobi', 'maasai mara': 'Africa/Nairobi',
  'amboseli': 'Africa/Nairobi', 'tsavo': 'Africa/Nairobi', 'laikipia': 'Africa/Nairobi',
  'serengeti': 'Africa/Dar_es_Salaam', 'ngorongoro': 'Africa/Dar_es_Salaam',
  'arusha': 'Africa/Dar_es_Salaam', 'kilimanjaro': 'Africa/Dar_es_Salaam',
  'victoria falls': 'Africa/Harare', 'livingstone': 'Africa/Lusaka',
  'okavango': 'Africa/Gaborone', 'okavango delta': 'Africa/Gaborone', 'maun': 'Africa/Gaborone',
  'windhoek': 'Africa/Windhoek', 'etosha': 'Africa/Windhoek', 'sossusvlei': 'Africa/Windhoek',
  'kigali': 'Africa/Kigali', 'volcanoes national park': 'Africa/Kigali',
};

// ─── Country to Default Timezone ────────────────────────────────────────────

export const COUNTRY_TO_TIMEZONE = {
  'france': 'Europe/Paris', 'spain': 'Europe/Madrid', 'italy': 'Europe/Rome',
  'germany': 'Europe/Berlin', 'uk': 'Europe/London', 'england': 'Europe/London',
  'scotland': 'Europe/London', 'ireland': 'Europe/Dublin', 'portugal': 'Europe/Lisbon',
  'greece': 'Europe/Athens', 'turkey': 'Europe/Istanbul', 'switzerland': 'Europe/Zurich',
  'austria': 'Europe/Vienna', 'netherlands': 'Europe/Amsterdam', 'belgium': 'Europe/Brussels',
  'czech republic': 'Europe/Prague', 'czechia': 'Europe/Prague', 'hungary': 'Europe/Budapest',
  'poland': 'Europe/Warsaw', 'croatia': 'Europe/Zagreb', 'norway': 'Europe/Oslo',
  'sweden': 'Europe/Stockholm', 'denmark': 'Europe/Copenhagen', 'finland': 'Europe/Helsinki',
  'iceland': 'Atlantic/Reykjavik', 'romania': 'Europe/Bucharest',
  'japan': 'Asia/Tokyo', 'south korea': 'Asia/Seoul', 'china': 'Asia/Shanghai',
  'thailand': 'Asia/Bangkok', 'vietnam': 'Asia/Ho_Chi_Minh', 'indonesia': 'Asia/Jakarta',
  'malaysia': 'Asia/Kuala_Lumpur', 'singapore': 'Asia/Singapore', 'philippines': 'Asia/Manila',
  'india': 'Asia/Kolkata', 'sri lanka': 'Asia/Colombo', 'nepal': 'Asia/Kathmandu',
  'uae': 'Asia/Dubai', 'qatar': 'Asia/Qatar', 'saudi arabia': 'Asia/Riyadh',
  'israel': 'Asia/Jerusalem', 'jordan': 'Asia/Amman', 'oman': 'Asia/Muscat',
  'australia': 'Australia/Sydney', 'new zealand': 'Pacific/Auckland',
  'fiji': 'Pacific/Fiji', 'tahiti': 'Pacific/Tahiti', 'maldives': 'Indian/Maldives',
  'seychelles': 'Indian/Mahe', 'mauritius': 'Indian/Mauritius',
  'mexico': 'America/Mexico_City', 'colombia': 'America/Bogota', 'peru': 'America/Lima',
  'argentina': 'America/Argentina/Buenos_Aires', 'brazil': 'America/Sao_Paulo',
  'chile': 'America/Santiago', 'costa rica': 'America/Costa_Rica',
  'egypt': 'Africa/Cairo', 'morocco': 'Africa/Casablanca', 'south africa': 'Africa/Johannesburg',
  'kenya': 'Africa/Nairobi', 'tanzania': 'Africa/Dar_es_Salaam', 'rwanda': 'Africa/Kigali',
  'mozambique': 'Africa/Maputo', 'botswana': 'Africa/Gaborone', 'namibia': 'Africa/Windhoek',
  'zimbabwe': 'Africa/Harare', 'zambia': 'Africa/Lusaka', 'uganda': 'Africa/Kampala',
  'ethiopia': 'Africa/Addis_Ababa', 'ghana': 'Africa/Accra', 'nigeria': 'Africa/Lagos',
  'madagascar': 'Indian/Antananarivo',
  'cambodia': 'Asia/Phnom_Penh', 'taiwan': 'Asia/Taipei', 'hong kong': 'Asia/Hong_Kong',
};

// ─── Timezone Functions (parameterized for cache injection) ─────────────────

/**
 * Get IANA timezone identifier for a city.
 * @param {string} cityName
 * @param {object} helpers - { dynamicTimezoneCache, getCityCountrySync }
 */
export const getCityIANATimezone = (cityName, helpers = {}) => {
  if (!cityName) return null;
  const { dynamicTimezoneCache = {}, getCityCountrySync = null } = helpers;
  const cityLower = cityName.toLowerCase().split(',')[0].trim();

  // 1. Direct lookup in static map
  const direct = CITY_TO_IANA_TIMEZONE[cityLower];
  if (direct) return direct;

  // 1b. Try stripping common suffixes ("New York City" → "New York", "Ho Chi Minh City" → "Ho Chi Minh")
  const stripped = cityLower.replace(/\s+(city|town|metro|area|region)$/i, '').trim();
  if (stripped !== cityLower && CITY_TO_IANA_TIMEZONE[stripped]) return CITY_TO_IANA_TIMEZONE[stripped];

  // 2. Check dynamic cache
  if (dynamicTimezoneCache[cityLower]) return dynamicTimezoneCache[cityLower];
  if (stripped !== cityLower && dynamicTimezoneCache[stripped]) return dynamicTimezoneCache[stripped];

  // 3. Try country part if "City, Country" format
  const parts = cityName.toLowerCase().split(',').map(p => p.trim());
  if (parts.length >= 2) {
    const countryPart = parts[parts.length - 1];
    if (COUNTRY_TO_TIMEZONE[countryPart]) return COUNTRY_TO_TIMEZONE[countryPart];
  }

  // 4. Check if the city name itself contains a country name
  for (const [country, tz] of Object.entries(COUNTRY_TO_TIMEZONE)) {
    if (cityLower.includes(country)) return tz;
  }

  // 5. Try getCityCountrySync for country-based fallback
  if (typeof getCityCountrySync === 'function') {
    const country = getCityCountrySync(cityName);
    if (country) {
      const countryLower = country.toLowerCase();
      if (COUNTRY_TO_TIMEZONE[countryLower]) return COUNTRY_TO_TIMEZONE[countryLower];
    }
  }

  return null;
};

/**
 * Get timezone offset for a city at a specific date (DST-aware).
 * Returns offset in hours from UTC.
 * @param {string} cityName
 * @param {Date|null} date
 * @param {object} helpers - { dynamicTimezoneCache, getCityCountrySync }
 */
export const getCityTimezoneOffset = (cityName, date = null, helpers = {}) => {
  if (!cityName) return 0;
  const iana = getCityIANATimezone(cityName, helpers);
  if (!iana) return 0;

  try {
    const targetDate = date || new Date();
    const formatter = new Intl.DateTimeFormat('en-US', {
      timeZone: iana,
      timeZoneName: 'shortOffset'
    });
    const parts = formatter.formatToParts(targetDate);
    const tzPart = parts.find(p => p.type === 'timeZoneName');
    if (tzPart) {
      const match = tzPart.value.match(/GMT([+-]?)(\d+)?(?::(\d+))?/);
      if (match) {
        const sign = match[1] === '-' ? -1 : 1;
        const hours = parseInt(match[2] || '0');
        const minutes = parseInt(match[3] || '0');
        return sign * (hours + minutes / 60);
      }
    }
    return 0;
  } catch (e) {
    return 0;
  }
};

/**
 * Get timezone abbreviation (e.g. "EST", "CET", "JST") for a city at a given date.
 * Uses Intl.DateTimeFormat with timeZoneName: 'short' for DST-aware abbreviations.
 * @param {string} cityName
 * @param {Date|null} date
 * @param {object} helpers - { dynamicTimezoneCache, getCityCountrySync }
 * @returns {string|null} e.g. "EST", "CET", "JST", or null if unknown
 */
export const getTimezoneAbbr = (cityName, date = null, helpers = {}) => {
  if (!cityName) return null;
  const iana = getCityIANATimezone(cityName, helpers);
  if (!iana) return null;

  try {
    const targetDate = date || new Date();
    const formatter = new Intl.DateTimeFormat('en-US', {
      timeZone: iana,
      timeZoneName: 'short'
    });
    const parts = formatter.formatToParts(targetDate);
    const tzPart = parts.find(p => p.type === 'timeZoneName');
    if (tzPart) {
      // Intl returns things like "EST", "CET", "GMT+9", etc.
      return tzPart.value;
    }
    return null;
  } catch (e) {
    return null;
  }
};

/**
 * Compute arrival day offset from departure and arrival local times + timezone difference.
 * For overnight flights where we have both local times but not exact duration.
 *
 * Logic: converts arrival time to departure timezone, checks if it crossed midnight.
 * Example: depart 20:00 EST, arrive 09:00 CET (UTC+1 vs UTC-5, diff=+6)
 *   → arrival in departure tz = 09:00 - 6hr = 03:00 EST (next day)
 *   → 03:00 < 20:00 departure → crossed midnight → dayOffset = 1
 *
 * @param {string} departureTime - "HH:MM" in departure city local time
 * @param {string} arrivalTime - "HH:MM" in arrival city local time
 * @param {number} timezoneDiff - hours (toOffset - fromOffset)
 * @param {number|null} durationMinutes - if known, use for precise calculation
 * @returns {number} dayOffset (0 = same day, 1 = next day, etc.)
 */
export const computeArrivalDayOffset = (departureTime, arrivalTime, timezoneDiff = 0, durationMinutes = null) => {
  if (!departureTime || !arrivalTime) return 0;

  const [depH, depM] = departureTime.split(':').map(Number);
  const [arrH, arrM] = arrivalTime.split(':').map(Number);
  const depMin = (depH || 0) * 60 + (depM || 0);
  const arrMin = (arrH || 0) * 60 + (arrM || 0);

  // If we have exact duration, use it for precise calculation
  if (durationMinutes != null && durationMinutes > 0) {
    const rawArrival = depMin + durationMinutes + (timezoneDiff * 60);
    if (rawArrival >= 1440) return Math.floor(rawArrival / 1440);
    if (rawArrival < 0) return Math.floor(rawArrival / 1440);
    return 0;
  }

  // Heuristic: convert arrival to departure timezone, check if day wrapped
  // arrivalInDepTz = arrivalMinutes - timezoneDiff (in hours) * 60
  const arrivalInDepTz = arrMin - (timezoneDiff * 60);

  // If arrival (in departure tz) is earlier than departure, the flight crossed midnight
  // Also account for very long flights (>24h) by checking if duration seems unreasonable
  if (arrivalInDepTz < depMin) {
    // Crossed midnight at least once
    // Estimated flight time = (arrivalInDepTz + 1440 - depMin) minutes
    const estimatedFlightMin = arrivalInDepTz + 1440 - depMin;
    // If estimated flight > 24h, it's likely a 2-day journey, but most commercial flights are <24h
    return estimatedFlightMin > 1440 ? 2 : 1;
  }

  return 0;
};

/**
 * Calculate local arrival time given departure time, flight duration, and timezones.
 * Returns { localArrivalTime, dayOffset, timezoneNote, timezoneDiff }.
 * @param {string} departureTime - "HH:MM"
 * @param {number} flightDurationHours
 * @param {string} fromCity
 * @param {string} toCity
 * @param {Date|null} travelDate
 * @param {object} helpers - { dynamicTimezoneCache, getCityCountrySync }
 */
export const calculateFlightArrival = (departureTime, flightDurationHours, fromCity, toCity, travelDate = null, helpers = {}) => {
  const fromOffset = getCityTimezoneOffset(fromCity, travelDate, helpers);
  const toOffset = getCityTimezoneOffset(toCity, travelDate, helpers);
  const timezoneDiff = toOffset - fromOffset;

  const [depHours, depMins] = departureTime.split(':').map(Number);
  const departureMinutes = depHours * 60 + depMins;

  const flightMinutes = Math.round(flightDurationHours * 60);
  const arrivalMinutesRaw = departureMinutes + flightMinutes + (timezoneDiff * 60);

  let dayOffset = 0;
  let arrivalMinutes = arrivalMinutesRaw;

  if (arrivalMinutes >= 1440) {
    dayOffset = Math.floor(arrivalMinutes / 1440);
    arrivalMinutes = arrivalMinutes % 1440;
  } else if (arrivalMinutes < 0) {
    dayOffset = Math.floor(arrivalMinutes / 1440);
    arrivalMinutes = ((arrivalMinutes % 1440) + 1440) % 1440;
  }

  const arrivalHours = Math.floor(arrivalMinutes / 60);
  const arrivalMins = arrivalMinutes % 60;

  return {
    localArrivalTime: `${String(arrivalHours).padStart(2, '0')}:${String(arrivalMins).padStart(2, '0')}`,
    dayOffset: dayOffset,
    timezoneNote: timezoneDiff !== 0 ? `(${timezoneDiff > 0 ? '+' : ''}${timezoneDiff}hr time zone change)` : '',
    timezoneDiff: timezoneDiff
  };
};
